import { ApiEndpoints } from '../../../shared/webservices/endpoint';
import GenericRequest, { METHOD_PUT } from '../../../shared/webservices/GenericRequest';

export default class AddSchemeDocumentRequest extends GenericRequest {

    schemeDocument;

    constructor(schemeDocument) {
        super(METHOD_PUT, ApiEndpoints.DOCUMENTS_SCHEMAS);

        this.schemeDocument = schemeDocument;
    }

    overrideRequest() {
        let request = {};
        if ( this.schemeDocument ) request = { ...request, ...this.schemeDocument };
        return request;
    }
}



// WEBPACK FOOTER //
// ./src/app/documents/ws/schemes/AddSchemeDocumentRequest.js